import { __formatString, __forConfiguration } from './extensions';

String.prototype.format = __formatString;
String.prototype.forConfiguration = __forConfiguration;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./src/helper/string-extensions/index.ts